import React from "react";
import { string } from "prop-types";

const Play = ({ color = "#8F0F01" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.821 27.227" >
    <path fill="#FFFFFF" d="M22.566,11.425L3.849,0.359c-1.2-0.725-2.76-0.339-3.485,0.86c-0.243,0.403-0.37,0.865-0.365,1.336v22.123
        c-0.003,1.408,1.135,2.553,2.544,2.556c0.46,0.001,0.911-0.122,1.306-0.356l18.718-11.06c1.213-0.716,1.616-2.279,0.9-3.492
        c-0.219-0.371-0.529-0.681-0.9-0.9L22.566,11.425z"/>
    </svg>
  );
};

Play.propTypes = {
  color: string
};

export default Play;
